export default "__VITE_ASSET__5971e51c__"